/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import Calendar from 'ui/components/meetings/Calendar.vue';
import ListExportModal from 'shared/ui/components/modals/ListExportModal.vue';
import ModalForm from 'shared/ui/components/form-components/ModalForm.vue';
import SearchBar from 'shared/ui/components/form-components/SearchBar.vue';
import Toggler from 'shared/ui/components/form-components/Toggler.vue';

const __vue_script__ = {
    name: 'MeetingsCalendar',

    components: {
        Calendar,
        SearchBar,
        Toggler
    },

    props: {
        params: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            reloadSpy: 0,
            searchTerm: '',
            showSessions: this.$services.storage.get('show_sessions_in_meetings_calendar') || false,
            calendarActions: this.params.currentController.routeOptions.crudOpts?.actions
        };
    },

    watch: {
        showSessions(value) {
            this.$services.storage.set('show_sessions_in_meetings_calendar', value);
        }
    },

    methods: {
        /**
         * Returns the Excel import href for the meetings list.
         * @returns {string} The Excel import href.
         */
        getExcelImportHref() {
            return this.$utils.modules.getRouteHref(this.params.module, 'import-meeting', { eventId: this.params.event._id });
        },

        /**
         * Opens the new meeting form modal
         */
        openMeetingEditor(event, resource) {
            const model = {};

            if (event) {
                const start_ts = this.$utils.time.dateToUnix(event.start);
                const end_ts = this.$utils.time.dateToUnix(event.end);
                const meeting = {
                    title: event.title,
                    start_ts, duration: (end_ts - start_ts).toString(),
                    __event: event
                };

                if (resource?.type === 'person') {
                    meeting.organizer = resource?.origin;
                } else {
                    meeting.meeting_location = event.resource;
                }

                Object.assign(model, meeting);
            }

            this.$modal.show(ModalForm, {
                title: this.$t('listings.actions.new_meeting'),
                event: this.params.event,
                model,
                fpType: 'meeting',
                singlePanel: true,
                onSave: () => this.reloadSpy = Date.now(),
                onClose: this.onEditorClosed,
                onError: () => this.reloadSpy = Date.now(),
            }, {
                classes: 'medium',
                height: 'auto',
                clickToClose: false
            });
        },

        /**
         * Opens the export users list modal
         */
        openExportModal() {
            this.$modal.show(ListExportModal, {
                title: 'Meetings',
                fpType: 'meeting',
                exporter: 'lib/meetings/fp-type-exporter',
                event: this.params.event
            }, {
                classes: 'small',
                height: 'auto',
                clickToClose: false
            });
        },

        /**
         * Callback function called when the editor is closed.
         *
         * @param {string} reason - The reason for closing the editor.
         * @param {object} model - The model object representing the editor.
         */
        onEditorClosed(reason, model) {
            console.info('[MeetingsCalendar] Editor closed', reason, model);

            if (reason === 'editor-abort' && model?.__event) {
                this.$refs.calendar.removeEvent(model.__event);
            }
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"meetings-calendar"},[_c('header',[_c('search-bar',{attrs:{"show-no-result":false},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}}),_c('a',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.openMeetingEditor()}}},[_vm._v(_vm._s(_vm.$t('listings.actions.new_meeting')))]),_c('a',{staticClass:"btn",on:{"click":function($event){return _vm.openExportModal()}}},[_vm._v(_vm._s(_vm.$t('listings.actions.export_xls')))]),_c('a',{staticClass:"btn",attrs:{"href":_vm.getExcelImportHref()}},[_vm._v(_vm._s(_vm.$t('listings.actions.import_xls')))]),_c('toggler',{attrs:{"name":"show_sessions","on-label":_vm.$t('meetings.calendar.filters.show_daily_sessions'),"off-label":_vm.$t('meetings.calendar.filters.show_daily_sessions')},model:{value:(_vm.showSessions),callback:function ($$v) {_vm.showSessions=$$v},expression:"showSessions"}})],1),_c('calendar',{ref:"calendar",attrs:{"event":_vm.params.event,"user":_vm.params.user,"module":_vm.params.module,"search-term":_vm.searchTerm,"show-sessions":_vm.showSessions,"reload-spy":_vm.reloadSpy,"actions":_vm.calendarActions},on:{"editor-closed":_vm.onEditorClosed,"create":_vm.openMeetingEditor}}),_c('footer',[_c('div',{staticClass:"legend"},[_c('v-popover',{attrs:{"delay":0,"trigger":"hover click focus","popover-inner-class":"tooltip-inner popover-inner meeting-legend-popover","boundaries-element":"span"}},[_c('i',{staticClass:"ic-info-fill"}),_vm._v(_vm._s(_vm.$t('meetings.details.statuses.legend'))),_c('template',{slot:"popover"},[_c('p',[_vm._v(_vm._s(_vm.$t('meetings.details.info_popover.meeting_statuses')))]),_c('ul',[_c('li',[_vm._v(_vm._s(_vm.$t('meetings.details.info_popover.confirmed')))]),_c('li',[_vm._v(_vm._s(_vm.$t('meetings.details.info_popover.invited')))]),_c('li',[_vm._v(_vm._s(_vm.$t('meetings.details.info_popover.declined')))])]),_c('p',[_vm._v(_vm._s(_vm.$t('meetings.details.info_popover.other_titles')))]),_c('ul',[_c('li',[_vm._v(_vm._s(_vm.$t('meetings.details.info_popover.agenda_items')))]),_c('li',[_vm._v(_vm._s(_vm.$t('meetings.details.info_popover.unavailable_slots')))])])])],2),_c('div',{staticClass:"item confirmed"},[_c('i'),_vm._v(_vm._s(_vm.$t('meetings.details.statuses.confirmed')))]),_c('div',{staticClass:"item invited"},[_c('i'),_vm._v(_vm._s(_vm.$t('meetings.details.statuses.invited')))]),_c('div',{staticClass:"item declined"},[_c('i'),_vm._v(_vm._s(_vm.$t('meetings.details.statuses.declined')))]),_vm._m(0),_c('div',{staticClass:"item agenda"},[_c('i'),_vm._v(_vm._s(_vm.$t('meetings.details.statuses.agenda')))]),_c('div',{staticClass:"item unavailable"},[_c('i'),_vm._v(_vm._s(_vm.$t('meetings.details.statuses.unavailable')))])],1)])],1)}
var __vue_staticRenderFns__ = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item separator"},[_c('i')])}]

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "MeetingsCalendar.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__